import * as yup from 'yup';

export const bloggerCardSchema = yup.object().shape({
  audienceReach: yup.number().typeError('Must be a number').min(0),
  accountQuality: yup.number().typeError('Must be a number').min(0).max(10),
  storiesViews: yup.number().typeError('Must be a number').min(0),
  recommendedPrice: yup.number().typeError('Must be a number').min(0),
});
